import { useEffect, useRef } from 'react';
import Checkbox from './Checkbox';
import { LOCAL_STORAGE_TOKEN } from '../Utilities/Config';

import '../Styles/Tips.css';

export default function Tips(props) {
	const { show, onToggle, disclaimerAgreed, language } = props;
	const windowReference = useRef(null);
	const closeButtonReference = useRef(null);
	const hideDisclaimerWindow = useRef(false);

	// Close on clicking outside of window
	const handleClickOutside = (e) => {
		if (!windowReference.current.contains(e.target)) onToggle(false);
	};

	// Close on button click
	const onCloseClick = () => {
		if (hideDisclaimerWindow.current.checked === true) {
			localStorage.setItem(LOCAL_STORAGE_TOKEN, JSON.stringify(true));
		}
		onToggle(false);
	}

	useEffect(() => {
		if (disclaimerAgreed) {
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}
	});

	return (
		<div className={show ? 'modal-disclaimer-wrapper show': 'modal-disclaimer-wrapper'}>
			<div tabIndex="0" ref={windowReference} className={show ? 'modal-disclaimer show': 'modal-disclaimer'}>
					<div className="modal-disclaimer-header-wrapper">
						<div className="header">{language['tips:header:title'] || 'How to use the map'}</div>
						<button ref={closeButtonReference} className="button-close" onClick={onCloseClick} aria-label='Close window'></button>
					</div>
					<div className="content scroller">
						<div className="description">

							<div className="disclaimer-block horizontal">
								<div className="disclaimer-block-image-wrapper"><div className="disclaimer-block-image"><img className="disclaimer-image-inline scroll" src={`${process.env.PUBLIC_URL}/images/disclaimer-zoom.svg`} alt="zoom"/></div></div>
								<div className="disclaimer-block-description">{language['tips:content:zoom'] || 'Zoom in on the map for a detailed view at the municipality level.'}</div>
							</div>

							<div className="disclaimer-block horizontal">
								<div className="disclaimer-block-image-wrapper"><div className="disclaimer-block-image"><img className="disclaimer-image-inline" src={`${process.env.PUBLIC_URL}/images/disclaimer-click.png`} alt="click"/></div></div>
								<div className="disclaimer-block-description">{language['tips:content:click'] || 'Click on the map to see more details about the respective municipality or district.'}</div>
							</div>

							<div className="disclaimer-block horizontal">
								<div className="disclaimer-block-image-wrapper"><div className="disclaimer-block-image"><div className="disclaimer-search"></div></div></div>
								<div className="disclaimer-block-description">{language['tips:content:search'] || 'If you are on a public water supply, put your address into the search box to find council monitored nitrate levels for your area.'}</div>
							</div>

						</div>
					</div>
					<div className="info-button-wrapper vertical">
						<button className="gp-button-info" onClick={onCloseClick} aria-label={language['tips:controls:btn:open_map'] || 'Open the map'}>{language['tips:controls:btn:open_map'] || 'Open the map'}</button>
						<div className="checkbox-show-window">
							<Checkbox
								ref={hideDisclaimerWindow}
								title={language['tips:controls:checkbox'] || "Do not show this pop-up window again."}
							/>
						</div>
					</div>
			</div>
		</div>
	);
}
